import axios from "axios";
import {BASE_PATH} from "../services/api";

export const getBrojProizvodaPoProdavnicama = () => {
    return axios.get(BASE_PATH + "/admin/broj-proizvoda-po-prodavnicama", {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    });
};

export const getOStalaAnalitika = () => {
    return axios.get(BASE_PATH + "/admin/ostala-analitika", {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    });
};